/* global EpgEnabled, ProfileEnabled OptimizelyInitWindowWatch */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Waypoint } from 'react-waypoint';
import _ from 'lodash';
import ReactTimeout from 'react-timeout';
import BreadcrumbsComponent, { breadcrumbsWatchParser } from 'components/Breadcrumbs';
import Loader from 'components/Loader';
import { WATCH_RELATED_THUMBNAIL_IMAGE, renderImage } from 'helpers/ImageHelper';
import {
  activateOptimizely,
  triggerWatchInitVariables,
  deactivateWatchInitVariables,
  getOptimizelyUnlockedVideoPage,
  getOptimizelyRemovedSeries,
} from 'helpers/OptimizelyHelper';
import { helperGetHomeUrl, helperGetLiveUrl, getPreviousPathname } from 'helpers/RouteHelper';
import {
  clearVideo as clearGlobalVideo,
  fetchVideoPanel as fetchGlobalVideoPanel,
  setDisableRender as setGlobalVideoDisabled,
  clearLiveRestart as clearGlobalLiveRestart,
  setScreenInControlOfState as setGlobalPlayerScreenInControlOfState,
  setVideoPanel as setGlobalVideoPanel,
  handleVodSectionClicked,
} from 'components/VideoPlayerGlobal/Actions';
import { setRecommendationIdAction as setRecommendationId } from 'index/AppActions';
import { PAGE_WATCH } from 'helpers/PageHelper';
import { renderGrid } from 'helpers/GridHelper';
import {
  createSchemaTag,
  createWatchEpisodeSchema,
  createWatchClipSchema,
} from 'helpers/SchemaHelper';
import { getCookie } from 'helpers/Storage';
import {
  watchVideoProcessor,
  watchListVideoProcessor,
  watchPlaylistVideoProcessor,
  watchListPlaylistVideoProcessor,
} from 'helpers/VideoProcessorHelper';
import {
  COLLECTION_TYPE_LOCAL_CLIPS,
  FOX,
  getErrorComponent,
  getLocalClipPage,
  getLocalClipSectionTitle,
  isMovie,
  isClip,
  isStaticRender,
  LOCAL_CLIP_PAGE_COOKIE_NAME,
  setLocalChannelCookies,
  setLocalClipPage,
} from 'helpers/ContentHelper';
import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
} from 'helpers/BreakpointHelper';
import {
  Events,
  checkRecommendationIdOnClick,
  getSegmentModelMetadata,
  getSegmentAnonymousId,
  handleTealiumButtonAction,
  PageNames,
  SegmentActionLocations,
  setOptimizelyCollectionViewedEvent,
  trackPageReferrerAnalytics,
  handleAnalytics,
} from '@foxcorp/delta-web-analytics';
import { brandOverrideMetaTags, setHelmetTags } from 'helpers/HelmetHelper';
import breadcrumbsTheme from 'screens/Watch/styles/Breadcrumbs.css';
import { fetchPCS } from 'components/Account/AccountComponents/ParentalControls/ParentalControlsActions';
import tileGridTheme from './styles/WatchTileGrid.css';
import tileStyle from './styles/WatchTile.module.scss';
import Style from './Watch.module.scss';
import { fetchWatch, fetchWatchPanels, clearWatch, fetchMovieDetail } from './WatchActions';
import { getSectionTitleData, PANEL_TYPE_VIDEOS, RESTART_TYPE_LIVE } from './WatchHelpers';

import {
  makeSelectAppRecommendationIdData,
  makeSelectGlobalUpNextHeadline,
  makeSelectGlobalUpNextVideo,
  makeSelectGlobalVideoPanelVideo,
  makeSelectGlobalVideoRestartVideo,
  makeSelectGlobalVideoVideo,
} from './selectors';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    suppressNetworkIcon: false,
    defaultHideAltHeader: false,
    canHideControls: true,
    renderInfoInDetail: false,
    gridToggleLimit: 4,
    gridPrimaryToggleLimit: 4,
    gridMovieToggleLimit: 8,
    gridUpNextToggleLimit: 15,
    renderList: false,
    playerMetadataOverlay: true,
  },
  [SITE_PLATFORM_WEB]: {
    suppressNetworkIcon: false,
    defaultHideAltHeader: false,
    canHideControls: true,
    renderInfoInDetail: false,
    gridToggleLimit: 4,
    gridPrimaryToggleLimit: 4,
    gridMovieToggleLimit: 8,
    gridUpNextToggleLimit: 12,
    renderList: false,
    playerMetadataOverlay: true,
  },
  [SITE_PLATFORM_TABLET]: {
    suppressNetworkIcon: false,
    defaultHideAltHeader: true,
    canHideControls: false,
    renderInfoInDetail: true,
    gridToggleLimit: 3,
    gridPrimaryToggleLimit: 6,
    gridMovieToggleLimit: 3,
    renderList: true,
    playerMetadataOverlay: false,
    overrideShowNetworkBug: true,
  },
  [SITE_PLATFORM_MOBILE]: {
    suppressNetworkIcon: false,
    defaultHideAltHeader: true,
    canHideControls: false,
    renderInfoInDetail: true,
    gridToggleLimit: 3,
    gridPrimaryToggleLimit: 6,
    gridMovieToggleLimit: 3,
    renderList: true,
    playerMetadataOverlay: false,
    overrideShowNetworkBug: true,
  },
};

const PREROLL_EXPERIMENT_KEY = 'video_cbp_override_test';
const PREROLL_FEATURE_KEY = 'video_cbp_override';
const PREROLL_VARIATION_CONTROL = 'control';

class Watch extends Component {
  constructor(props) {
    super(props);
    const { panels } = this.props;
    const primaryType = _.get(panels, 'member.0.items.member.0.videoType');
    this.state = {
      playlist: null,
      upNextPanel: null,
      primaryPanels: null,
    };
    this.state.upNextPanel = this.renderUpNextPanelVideos();
    this.state.primaryPanels = this.renderPrimaryPanels(primaryType);
    this.ignoreUnmountReferrerAnalytics = false;
    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
    this.panelRenderPosition = 0;
    this.panelsRendered = new Map();
  }

  componentDidMount() {
    const {
      account,
      setGlobalPlayerScreenInControlOfState,
      setGlobalVideoDisabled,
      setWatchPage,
      accessToken,
      fetchPCS,
    } = this.props;
    if (setWatchPage) setWatchPage(true);
    activateOptimizely();
    const source = PAGE_WATCH;
    setGlobalPlayerScreenInControlOfState(source);
    this.fetchWatchData();
    setGlobalVideoDisabled({ value: false, source });
    if (account) fetchPCS(accessToken);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { fetchWatchPanels, params } = this.props;
    const { deviceId, params: nextParams, accessToken: nextAccessToken } = nextProps;
    const optimizelyProps = {
      callback: this.triggerPrerollOptimizely,
    };

    const videoId = _.get(params, 'videoId');
    const nextVideoId = _.get(nextParams, 'videoId');

    if (videoId !== nextVideoId) {
      fetchWatchPanels(nextVideoId, nextAccessToken, deviceId, false, optimizelyProps);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const newState = this.getChangingState(nextState);
    const oldState = this.getChangingState(this.state);
    const newProps = this.getChangingProps(nextProps);
    const oldProps = this.getChangingProps(this.props);
    return !_.isEqual(newProps, oldProps) || !_.isEqual(newState, oldState);
  }

  componentDidUpdate(prevProps) {
    const {
      accessToken,
      breakpoint,
      deviceId,
      fetchMovieDetail,
      isVodUnavailable,
      location,
      panels,
      panelVideo,
      upNextVideo,
      video,
    } = this.props;
    const {
      accessToken: prevAccessToken,
      breakpoint: prevBreakpoint,
      isVodUnavailable: prevIsVodUnavailable,
      panels: prevPanels,
      panelVideo: prevPanelVideo,
      upNextVideo: prevUpNextVideo,
      video: prevVideo,
    } = prevProps;
    const exemptValue = _.get(window, 'expmt_unlocked_video_page');
    if (!exemptValue) window.expmt_unlocked_video_page = null;
    const videoId = _.get(video, 'id');
    const prevVideoId = _.get(prevVideo, 'id');
    const videoChanged = videoId && prevVideoId !== videoId;
    const accessTokenChanged = accessToken !== prevAccessToken;
    const hash = _.trim(_.get(location, 'hash'), '#');
    const isLiveRestart = _.includes(hash, RESTART_TYPE_LIVE);
    const isDeeplink = !getPreviousPathname();
    const videoNotAvailable = !prevIsVodUnavailable && isVodUnavailable;
    if (videoNotAvailable && isDeeplink && isLiveRestart) {
      if (EpgEnabled) {
        browserHistory.push(helperGetLiveUrl());
      } else {
        // Redirects to home page for nation since it has no live page
        browserHistory.push(helperGetHomeUrl());
      }
    }
    if (accessTokenChanged) this.fetchWatchData();
    if (videoChanged) {
      const videoIsMovie = _.get(video, 'videoType') === 'movie';
      if (videoIsMovie) fetchMovieDetail(videoId, accessToken, deviceId);
    }
    if (OptimizelyInitWindowWatch && panelVideo && panelVideo?.id !== prevPanelVideo?.id) {
      triggerWatchInitVariables(
        panelVideo?.videoFormat,
        panelVideo?.showCode,
        panelVideo?.videoType,
        panelVideo?.network,
      );
    }

    if ((upNextVideo && upNextVideo !== prevUpNextVideo) || breakpoint !== prevBreakpoint) {
      this.setState({ upNextPanel: this.renderUpNextPanelVideos() });
    }
    if ((panels && panels !== prevPanels) || breakpoint !== prevBreakpoint) {
      const primaryType = _.get(panels, 'member.0.items.member.0.videoType');
      this.setState({ primaryPanels: this.renderPrimaryPanels(primaryType) });
    }
  }

  componentWillUnmount() {
    const {
      clearGlobalLiveRestart,
      clearGlobalVideo,
      clearWatch,
      restartVideo,
      setGlobalVideoDisabled,
      setWatchPage,
    } = this.props;
    const source = PAGE_WATCH;
    setLocalChannelCookies({ resetCookies: true });
    setGlobalVideoDisabled({ value: true, source });
    if (restartVideo) clearGlobalLiveRestart();
    clearGlobalVideo({ source });
    clearWatch();
    setWatchPage(false);
    deactivateWatchInitVariables();

    if (!this.ignoreUnmountReferrerAnalytics) {
      this.trackPageReferrerAnalytics({
        name: PageNames.PLAYER,
      });
    }
  }

  isOptimizelyUnlockedVideoPage = () => {
    const { breakpoint, globalVideo, panelVideo, video: reducerVideo } = this.props;

    const isDesktop = breakpoint === SITE_PLATFORM_WEB_LARGE || breakpoint === SITE_PLATFORM_WEB;
    const video = reducerVideo || panelVideo || globalVideo;
    const network = video?.network;
    const isVideoClip = video?.videoType === 'clip';
    const seriesName = video?.seriesName;
    const isValidSeries = getOptimizelyRemovedSeries(seriesName);
    const isEntertainmentContent =
      video?.isSeriesDetailAvailable && network === FOX && !isVideoClip && isValidSeries;

    return isDesktop && isEntertainmentContent && getOptimizelyUnlockedVideoPage();
  };

  getChangingProps = props => {
    const {
      account,
      accessToken,
      breakpoint,
      deviceId,
      errors,
      globalPanelVideo,
      globalVideo,
      hasAccount,
      isAuthenticated,
      isVodUnavailable,
      location,
      pagination,
      panelVideo,
      panels,
      params,
      playlistData,
      preauthorizedResources,
      recommendationIdData,
      restartVideo,
      seo,
      upNextHeadline,
      upNextVideo,
      video,
    } = props;
    return {
      account,
      accessToken,
      breakpoint,
      deviceId,
      errors,
      globalPanelVideo,
      globalVideo,
      hasAccount,
      isAuthenticated,
      isVodUnavailable,
      location,
      pagination,
      panelVideo,
      panels,
      params,
      playlistData,
      preauthorizedResources,
      recommendationIdData,
      restartVideo,
      seo,
      upNextHeadline,
      upNextVideo,
      video,
    };
  };

  getChangingState = state => {
    const { upNextPanel } = state;
    return {
      upNextPanel,
    };
  };

  onVodSectionClick = (opts = {}) => {
    const {
      clearGlobalLiveRestart,
      handleVodSectionClicked,
      setRecommendationId,
      recommendationIdData: currentRecIdData,
      restartVideo,
    } = this.props;
    const {
      account,
      itemIndex,
      originalItem,
      pageCollectionCount: page_collection_count,
      percentWatched,
      position,
      recommendationIdData,
      sectionTitle,
      subtitleText,
      titleText,
      uiElement,
    } = opts;
    if (restartVideo) clearGlobalLiveRestart();
    const isLocalClip = getCookie({ name: LOCAL_CLIP_PAGE_COOKIE_NAME });
    if (isLocalClip) {
      setLocalClipPage({
        value: originalItem?.playerScreenUrl,
        options: { path: '/' },
      });
    }
    const newRecIdData = recommendationIdData;
    checkRecommendationIdOnClick(currentRecIdData, newRecIdData, setRecommendationId);
    const isAnonymouslyResumingPlayback = !account && percentWatched;
    const vodClickedState = {
      anonymousResumeProfileUpsell: isAnonymouslyResumingPlayback && ProfileEnabled,
      anonymousResume: isAnonymouslyResumingPlayback && !ProfileEnabled,
      restartFromBeginning: false,
      isAuthError: false,
    };

    handleVodSectionClicked({ originalItem, vodClickedState });
    this.ignoreUnmountReferrerAnalytics = true;
    this.trackPageReferrerAnalytics({
      name: PageNames.VOD_SECTION,
    });

    const id = _.get(originalItem, 'id');
    const uID = _.get(originalItem, 'uID', '');
    const showCode = _.get(originalItem, 'showCode', '');
    if (id) {
      handleAnalytics({
        event: Events.PLAYLIST_BUTTON_ACTION,
        payload: {
          page_action_type: 'Watch Now',
          page_collection_count: page_collection_count - 1, // don't count the player panel
          page_collection_title: sectionTitle,
          page_item_title: titleText,
          page_item_subtitle: subtitleText,
          page_item_horizontal_position: itemIndex + 1,
          page_item_vertical_position: position,
          page_action_location: SegmentActionLocations.PLAYER,
          page_ui_element: uiElement,
          page_video_uid: uID || showCode,
          ...getSegmentModelMetadata(),
        },
      });

      this.panelRenderPosition = 0;
    }
  };

  segmentPlaylistButtonAction = (opts = {}) => {
    const { sectionTitle, subtitleText, titleText, uiElement } = opts;

    handleAnalytics({
      event: Events.PLAYLIST_BUTTON_ACTION,
      payload: {
        page_action_type: 'Watch Now',
        page_collection_title: sectionTitle,
        page_item_title: titleText,
        page_item_subtitle: subtitleText,
        page_action_location: SegmentActionLocations.PLAYER,
        page_ui_element: uiElement,
        ...getSegmentModelMetadata(),
      },
    });

    this.panelRenderPosition = 0;
  };

  getPaginationItemsFromPanelId = panelId => {
    const { pagination } = this.props;
    const paginationItems = _.get(pagination, `${panelId}`);
    if (!paginationItems) return [];
    return paginationItems.reduce((arr, items) => arr.concat(items.member), []);
  };

  getVideoId = () => {
    const { params } = this.props;
    return _.get(params, 'videoId');
  };

  triggerPrerollOptimizely = video => {
    const { optimizely } = this.props;
    const userId = getSegmentAnonymousId();
    const { videoType, network: video_network, showCode: video_series_id, isLiveNow } = video || {};
    const video_content_length_format = isClip(videoType) ? 'short-form' : 'long-form';
    const attributes = {
      video_content_type: isLiveNow ? 'live' : 'vod',
      video_network,
      video_series_id,
      video_content_length_format,
    };

    // TODO if preroll ads with experiments want to be enabled again do varification here
    const prerollVariationKey = false;

    // Return null if getVariation method returns falsy value which means user is not in experiment
    if (!prerollVariationKey) return null;
    // Call Optimizely activate method for each user in experiment
    optimizely.activate(PREROLL_EXPERIMENT_KEY, userId, attributes);

    if (prerollVariationKey && prerollVariationKey !== PREROLL_VARIATION_CONTROL) {
      if (prerollVariationKey) {
        const desktop = optimizely?.getFeatureVariableString(
          PREROLL_FEATURE_KEY,
          'ad_site_section_desktop',
          userId,
          attributes,
        );
        const tablet = optimizely?.getFeatureVariableString(
          PREROLL_FEATURE_KEY,
          'ad_site_section_tablet',
          userId,
          attributes,
        );
        const mobile = optimizely?.getFeatureVariableString(
          PREROLL_FEATURE_KEY,
          'ad_site_section_mobile',
          userId,
          attributes,
        );
        const siteSection = {
          [SITE_PLATFORM_WEB_LARGE]: desktop,
          [SITE_PLATFORM_WEB]: desktop,
          [SITE_PLATFORM_TABLET]: tablet,
          [SITE_PLATFORM_MOBILE]: mobile,
        };
        return { siteSection };
      }
    }
    return null;
  };

  fetchWatchData() {
    const {
      accessToken,
      deviceId,
      globalPanelVideo,
      fetchWatchPanels,
      restartVideo,
      setGlobalVideoPanel,
      video,
    } = this.props;
    const videoIsMovie = _.get(video, 'videoType') === 'movie';
    const id = this.getVideoId();
    const optimizelyProps = {
      callback: this.triggerPrerollOptimizely,
    };
    const videoIsSameAsGlobalVideo =
      !!globalPanelVideo && id === _.get(globalPanelVideo, 'id', null);
    let doNotSetGlobalVideoPanel = videoIsSameAsGlobalVideo;
    if (restartVideo) {
      doNotSetGlobalVideoPanel = true;
      setGlobalVideoPanel({ video: restartVideo, source: PAGE_WATCH });
      fetchWatchPanels(id, accessToken, deviceId, doNotSetGlobalVideoPanel, optimizelyProps);
    } else if (videoIsMovie && !isStaticRender()) {
      fetchMovieDetail(id, accessToken);
    } else if (fetchWatchPanels && !isStaticRender()) {
      fetchWatchPanels(id, accessToken, deviceId, doNotSetGlobalVideoPanel, optimizelyProps);
    }
  }

  usePlaylist() {
    const { playlistItems } = this.state;
    const { video } = this.props;
    const videoId = _.get(video, 'id');
    if (!playlistItems || !videoId) return false;
    return _.findKey(playlistItems, { id: videoId });
  }

  renderLoader() {
    const { globalVideo, panels, restartVideo, setLoading } = this.props;
    if (!panels && !globalVideo && !restartVideo) {
      return <Loader className={Style.loader} setLoading={setLoading} center />;
    }
    return null;
  }

  renderPanelVideos({ isFreeWatch = false, member, pageCollectionCount, position, primary }) {
    const {
      anonymousId,
      breakpoint,
      isAuthenticated,
      params,
      playlistData,
      preauthorizedResources,
    } = this.props;
    const { playlist, playlistItems } = this.state;
    const panelId = _.get(member, 'id');
    const paginationItems = this.getPaginationItemsFromPanelId(panelId);
    const videoId = _.get(params, 'videoId');
    const usePlaylistResponse = this.usePlaylist();
    if (!primary && usePlaylistResponse) return null;
    const {
      badge_nowPlaying: badge,
      freemium_watch_panel_title: freemiumWatchPanelTitle,
      paginationLessButton,
      paginationMoreButton,
    } = window.Language;

    const compactItems = _.compact([..._.get(member, 'items.member'), ...paginationItems]);
    const uniqueItems = _.uniqBy(compactItems, item => item.id);
    let defaultItems = _.map(uniqueItems, item =>
      _.assign({}, item, {
        isAuthenticated,
        preauthorizedResources,
      }),
    );

    if (
      videoId &&
      defaultItems.find(
        video => videoId === video.id && _.toLower(video.videoType) === 'fullepisode',
      )
    ) {
      // place current S/E first, all before it after
      const currentIndex = defaultItems.findIndex(item => item.id === videoId);
      const slicedItems = defaultItems.slice(currentIndex);
      const itemsBeforeCurrent = defaultItems.slice(0, currentIndex);
      defaultItems = [...slicedItems, ...itemsBeforeCurrent];
    }
    let items = defaultItems;
    let listProcessor = watchListVideoProcessor;
    let gridProcessor = watchVideoProcessor;
    if (usePlaylistResponse) {
      items = playlistItems;
      listProcessor = watchListPlaylistVideoProcessor.bind(this, playlist, {});
      gridProcessor = watchPlaylistVideoProcessor.bind(this, playlist, {});
    }
    items = _.map(items, item => {
      if (videoId === item.id) {
        return {
          ...item,
          contentLabel: [badge],
        };
      }
      return item;
    });
    const itemType = _.get(items, '0.videoType');
    const forceGrid = isMovie(itemType);
    const {
      gridToggleLimit,
      gridMovieToggleLimit,
      gridPrimaryToggleLimit,
      renderList,
    } = BREAKPOINTS[breakpoint];
    let toggleLimit = gridToggleLimit;
    if (isMovie(itemType)) {
      toggleLimit = gridMovieToggleLimit;
    } else if (primary) {
      toggleLimit = gridPrimaryToggleLimit;
    }

    const titleData = getSectionTitleData({
      sectionItems: items,
      theme: Style,
      member: usePlaylistResponse ? playlistData : member,
      primary,
      forceGrid,
      isPlaylist: usePlaylistResponse,
    });
    const sectionTitle =
      isFreeWatch && freemiumWatchPanelTitle ? freemiumWatchPanelTitle : titleData?.sectionTitle;
    const sectionTitleClass = titleData?.sectionTitleClass;
    const handleClick = opts => {
      this.onVodSectionClick({
        ...opts,
        pageCollectionCount,
        position,
        sectionTitle,
      });
    };
    const mobileOverrideBreakpoint = primary && !forceGrid ? renderList : false;
    const grid = renderGrid({
      gridProcessor,
      gridType: 'grid-4-1',
      isAuthenticated,
      items,
      key: 'filteredPanel',
      listProcessor,
      listTheme: tileStyle,
      onLinkClick: handleClick,
      onPlayClick: opts => this.segmentPlaylistButtonAction({ ...opts, sectionTitle }),
      onTileClick: handleClick,
      onTitleClick: handleClick,
      paginationLessButton,
      paginationMoreButton,
      preauthorizedResources,
      renderImage: image =>
        renderImage({
          breakpoint,
          imageType: WATCH_RELATED_THUMBNAIL_IMAGE,
          ...image,
        }),
      renderList: mobileOverrideBreakpoint,
      scrollSeeLess: true,
      shouldRenderButtons: true,
      showSeriesName: isFreeWatch,
      tileDetailToggle: true,
      tileGridTheme,
      tileGridTrackButtonClick: handleTealiumButtonAction,
      tileTheme: tileStyle,
      tileType: 'fadeAnimated',
      toggleLimit,
    });

    return (
      <Waypoint
        onEnter={() => {
          setOptimizelyCollectionViewedEvent({
            anonymousId,
            featuredTitle: sectionTitle,
            panelId,
            position,
          });
        }}
        bottomOffset="5%"
      >
        <div>
          {sectionTitle ? <h2 className={sectionTitleClass}>{sectionTitle}</h2> : null}
          {grid}
        </div>
      </Waypoint>
    );
  }

  renderUpNextPanelVideos = () => {
    const {
      breakpoint,
      isAuthenticated,
      preauthorizedResources,
      upNextHeadline,
      upNextVideo,
    } = this.props;

    const { gridUpNextToggleLimit, renderList } = BREAKPOINTS[breakpoint];

    if (!upNextVideo?.length) return null;

    const { paginationMoreButton, paginationLessButton } = window.Language;
    const isLocalClip = getCookie({ name: LOCAL_CLIP_PAGE_COOKIE_NAME });
    const listProcessor = watchListVideoProcessor;
    const gridProcessor = item =>
      watchVideoProcessor({
        ...item,
        collectionType: isLocalClip && COLLECTION_TYPE_LOCAL_CLIPS,
      });
    const items = upNextVideo;
    const handleClick = opts => this.onVodSectionClick({ ...opts, sectionTitle: upNextHeadline });

    const grid = renderGrid({
      collectionType: isLocalClip && COLLECTION_TYPE_LOCAL_CLIPS,
      gridProcessor,
      gridType: 'grid-5-4-3-1',
      isAuthenticated,
      items,
      key: 'filteredPanel',
      listProcessor,
      listTheme: tileStyle,
      onLinkClick: handleClick,
      onTileClick: handleClick,
      onTitleClick: handleClick,
      onPlayClick: opts =>
        this.segmentPlaylistButtonAction({ ...opts, sectionTitle: upNextHeadline }),
      paginationLessButton,
      paginationMoreButton,
      preauthorizedResources,
      renderList,
      renderImage: image =>
        renderImage({
          breakpoint,
          imageType: WATCH_RELATED_THUMBNAIL_IMAGE,
          ...image,
        }),
      scrollSeeLess: true,
      shouldRenderButtons: true,
      tileDetailToggle: true,
      tileGridTheme,
      tileGridTrackButtonClick: handleTealiumButtonAction,
      tileTheme: tileStyle,
      tileType: 'fadeAnimated',
      toggleLimit: gridUpNextToggleLimit,
    });

    return (
      <>
        <h2 className={Style.sectionTitle}>{upNextHeadline}</h2>
        {grid}
      </>
    );
  };

  handlePanelPosition = panelId => {
    if (this.panelsRendered?.has(panelId)) return;

    if (this.panelRenderPosition === 0 && this.isOptimizelyUnlockedVideoPage()) {
      this.panelRenderPosition = 2;
    } else {
      this.panelRenderPosition += 1;
    }

    this.panelsRendered?.set(panelId, this.panelRenderPosition);
  };

  renderPanels({ primary, primaryType }) {
    const { panels } = this.props;
    const panelList = _.get(panels, 'member');

    if (!panelList) return null;

    return panelList.map(member => {
      const id = _.get(member, '@id');
      const initialItems = _.get(member, 'items.member', []);
      const memberType = _.get(initialItems, '0.videoType');
      const panelType = _.get(member, 'panelType');
      if ((primaryType === memberType) !== primary) return null;

      switch (panelType) {
        case PANEL_TYPE_VIDEOS: {
          this.handlePanelPosition(id);

          return initialItems.length > 0 ? (
            <div key={id} className={Style.videos}>
              {this.renderPanelVideos({
                member,
                pageCollectionCount: panelList?.length,
                position: this.panelsRendered?.get(id),
                primary,
              })}
            </div>
          ) : null;
        }
        default:
          return null;
      }
    });
  }

  renderUnlockedPanels() {
    const { freemiumWatchPanel } = this.props;
    if (!freemiumWatchPanel) return null;
    const id = _.get(freemiumWatchPanel, '@id');
    const initialItems = _.get(freemiumWatchPanel, 'items.member', []);
    const panelType = _.get(freemiumWatchPanel, 'panelType');

    switch (panelType) {
      case PANEL_TYPE_VIDEOS: {
        return initialItems.length > 0 ? (
          <div key={id} className={Style.videos}>
            {this.renderPanelVideos({
              idx: 0,
              member: freemiumWatchPanel,
              position: 1,
              primary: false,
              isFreeWatch: true,
            })}
          </div>
        ) : null;
      }
      default:
        return null;
    }
  }

  renderPrimaryPanels = primaryType => (
    <>
      {this.renderPanels({ primary: true, primaryType })}
      {this.renderPanels({ primary: false, primaryType })}
    </>
  );

  render() {
    const { errors, globalVideo, panelVideo, seo, video: reducerVideo } = this.props;
    const { upNextPanel, primaryPanels } = this.state;
    if (errors && !_.isArray(errors)) return getErrorComponent(errors);
    const video = reducerVideo || panelVideo || globalVideo;
    const isLocalClip = getLocalClipPage();
    const localClipHeadline = getLocalClipSectionTitle();
    const network = _.get(video, 'network');
    const isVideoClip = video?.videoType === 'clip';
    const setOverrideMetatags = brandOverrideMetaTags(network);
    const schemaBuilder = isVideoClip ? createWatchClipSchema : createWatchEpisodeSchema;
    const tags = createSchemaTag({ item: video, getSchema: schemaBuilder });
    const shouldRenderUpNextPanels = !!isLocalClip;

    return (
      <>
        {setHelmetTags(seo)}
        {setHelmetTags({ tags: [tags] })}
        {setOverrideMetatags}
        {this.renderLoader()}
        <div className={Style.container}>
          <h1 className={Style.videoName}>{video?.name}</h1>
          {this.isOptimizelyUnlockedVideoPage() && this.renderUnlockedPanels()}
          {shouldRenderUpNextPanels ? upNextPanel : primaryPanels}
        </div>
        <BreadcrumbsComponent
          data={breadcrumbsWatchParser(video, isLocalClip, localClipHeadline)}
          theme={breadcrumbsTheme}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  const watchItems = [
    'endcardItems',
    'errors',
    'freemiumWatchPanel',
    'globalVideo',
    'isStatic',
    'isVodUnavailable',
    'pagination',
    'panels',
    'panelVideo',
    'releaseUrl',
    'schemaTags',
    'seo',
    'video',
  ];

  const watchProps = _.pick(state.watch, watchItems);
  return {
    ...watchProps,
    globalPanelVideo: makeSelectGlobalVideoPanelVideo(state),
    globalVideo: makeSelectGlobalVideoVideo(state),
    recommendationIdData: makeSelectAppRecommendationIdData(state),
    restartVideo: makeSelectGlobalVideoRestartVideo(state),
    upNextHeadline: makeSelectGlobalUpNextHeadline(state),
    upNextVideo: makeSelectGlobalUpNextVideo(state),
  };
}

Watch.fetchData = ({ store, params, accessToken }) => {
  const id = params.videoId;
  return store.dispatch(fetchWatch(id, accessToken)).then(response => {
    const panels = _.get(response, 'payload.data.panels');
    const videoType = _.get(panels, 'member.0.items.member.0.videoType');
    const isMovieType = videoType === 'movie';
    store.dispatch(setGlobalVideoDisabled({ value: false, context: PAGE_WATCH }));
    if (!isMovieType) return store.dispatch(fetchWatchPanels(id, accessToken));
    return store.dispatch(fetchMovieDetail(id, accessToken));
  });
};

Watch.defaultProps = {
  accessToken: null,
  deviceId: null,
  errors: null,
  globalPanelVideo: null,
  globalVideo: null,
  isAuthenticated: false,
  isVodUnavailable: null,
  location: {},
  optimizely: {},
  panels: {},
  panelVideo: null,
  playlistData: null,
  preauthorizedResources: [],
  recommendationIdData: null,
  restartVideo: null,
  seo: null,
  setLoading: null,
  setWatchPage: null,
  upNextHeadline: '',
  upNextVideo: [],
  video: {},
};

Watch.propTypes = {
  anonymousId: PropTypes.string,
  account: PropTypes.shape({}),
  accessToken: PropTypes.string,
  breakpoint: PropTypes.string.isRequired,
  clearGlobalLiveRestart: PropTypes.func.isRequired,
  clearGlobalVideo: PropTypes.func.isRequired,
  clearWatch: PropTypes.func.isRequired,
  deviceId: PropTypes.string,
  errors: PropTypes.number,
  freemiumWatchPanel: PropTypes.shape({}),
  fetchMovieDetail: PropTypes.func.isRequired,
  fetchPCS: PropTypes.func.isRequired,
  fetchWatchPanels: PropTypes.func.isRequired,
  globalPanelVideo: PropTypes.shape({}),
  globalVideo: PropTypes.shape({}),
  isAuthenticated: PropTypes.bool,
  isVodUnavailable: PropTypes.bool,
  location: PropTypes.shape({}),
  optimizely: PropTypes.shape({}),
  pagination: PropTypes.shape({}).isRequired,
  panelVideo: PropTypes.shape({}),
  panels: PropTypes.shape({
    itemsPerPage: PropTypes.number,
    member: PropTypes.arrayOf(PropTypes.shape({})),
    totalItems: PropTypes.number,
  }),
  params: PropTypes.shape({ videoId: PropTypes.string }).isRequired,
  playlistData: PropTypes.shape({}),
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  recommendationIdData: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  restartVideo: PropTypes.shape({}),
  seo: PropTypes.shape({}),
  setGlobalVideoDisabled: PropTypes.func.isRequired,
  setGlobalPlayerScreenInControlOfState: PropTypes.func.isRequired,
  setGlobalVideoPanel: PropTypes.func.isRequired,
  setLoading: PropTypes.func,
  setRecommendationId: PropTypes.func.isRequired,
  setWatchPage: PropTypes.func,
  handleVodSectionClicked: PropTypes.func.isRequired,
  upNextHeadline: PropTypes.string,
  upNextVideo: PropTypes.arrayOf(PropTypes.shape({})),
  video: PropTypes.shape({}),
};

const TimeoutWatch = ReactTimeout(
  connect(mapStateToProps, {
    clearGlobalLiveRestart,
    clearGlobalVideo,
    clearWatch,
    fetchGlobalVideoPanel,
    fetchMovieDetail,
    fetchPCS,
    fetchWatch,
    fetchWatchPanels,
    setGlobalVideoDisabled,
    setGlobalPlayerScreenInControlOfState,
    setGlobalVideoPanel,
    setRecommendationId,
    handleVodSectionClicked,
  })(Watch),
);

TimeoutWatch.fetchData = Watch.fetchData;

export default TimeoutWatch;
